module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.923bc494d832c471ee7b45ba38205fb9.woff2";